<select
  #inputField
  [(ngModel)]="params.value"
  class="form-control w-100 h-100"
  style="z-index: 100">
  @for (option of params.values; track option.value) {
    <option [value]="option.value">{{ option.label }}</option>
  }
</select>
